import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import { MuiButton } from "../../../components/mui";
import { MuiCol, MuiRow } from "../../../components/layout";
import { MuiTextArea, MuiTextField } from '../../../components/inputs';


function QuarantineView({values, onChange, onSave, ...props}) {
	const [palletCode, setPalletCode] = useState(values?.barcode ?? "");
	const [statusDate, setStatusDate] = useState(values?.statusDate ?? "");
	const [quarantineStatus, setQuarantineStatus] = useState(values?.note ?? "");

	useEffect(()=>{
		setPalletCode(values?.barcode ?? "");
		setStatusDate(values?.statusDate ?? "");
		setQuarantineStatus(values?.note ?? "");
	},[values]);

	function onClose(){
		props.onClose();
	}

	function save() {
		// onSave({
		// 	cmConfigId:values?.cmConfigId,
		// 	name:name,
		// 	netsuiteInternalId:netsuiteInternalId
		// })
	}

  return (
    <>
			<Dialog open={props.isOpen} onClose={onClose} disableEnforceFocus fullWidth>
				<DialogTitle>{t('pallet_quarantine.pallet_view_title')}</DialogTitle>
					<DialogContent>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextField label={t('pallet_quarantine.pallet_no')} disabled value={palletCode} onChange={setPalletCode}/>
								</MuiCol>
							</MuiRow>
							<br/>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextField label={t('pallet_quarantine.quarantine_date')} disabled value={statusDate} onChange={setStatusDate} />
								</MuiCol>
							</MuiRow>
							<MuiRow>
								<MuiCol size={12}>
									<MuiTextArea label={t('input.notes')} disabled value={quarantineStatus} onChange={setQuarantineStatus} />
								</MuiCol>
							</MuiRow>
					</DialogContent>
					<DialogActions>
						<MuiButton color="primary" onClick={onClose}>{t("close")}</MuiButton>
						<MuiButton color="primary" onClick={save}>{t("PASS")}</MuiButton>
					</DialogActions>
			</Dialog>
    </>
  );
}

QuarantineView.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(QuarantineView);